export const getDeviceId = () => {
  let id = localStorage.getItem("device-id");
  if (!id) {
    const array = new Uint8Array(16); // 128 Bit
    crypto.getRandomValues(array);
    id = Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
    localStorage.setItem("device-id", id);
  }
  return id;
};
